import PropTypes from 'prop-types';
import React, { Component, useState, useEffect } from 'react';

import { ChevronDown } from 'lucide-react';
import { Row, Col, Label, FormGroup, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Button, FormCard } from 'twyne-new.ui'

import Input from 'components/form/Input';

const propTypes = {
  data: PropTypes.object,
};

export default class AuthComponent extends Component {
  BasicAuth = ({ data: { username, password } }) => <>
    <Col>
      <Row>
        <Col size='6'>
          <FormGroup>
            <Label>Username</Label>
            <Input required
              value={username || ''}
              name='request_config.auth.basic.username'
            />
          </FormGroup>
        </Col>
        <Col size='6'>
          <FormGroup>
            <Label>Password</Label>
            <Input required
              value={password || ''}
              name='request_config.auth.basic.password'
            />
          </FormGroup>
        </Col>
      </Row>
    </Col>
  </>

  CarApi = ({ data: { api_token, api_secret } }) => <>
    <Col>
      <Row>
        <Col size='6'>
          <FormGroup>
            <Label>API Token</Label>
            <Input required
              value={api_token || ''}
              name='request_config.auth.carapi.api_token'
            />
          </FormGroup>
        </Col>
        <Col size='6'>
          <FormGroup>
            <Label>API Secret</Label>
            <Input required
              value={api_secret || ''}
              name='request_config.auth.carapi.api_secret'
            />
          </FormGroup>
        </Col>
      </Row>
    </Col>
  </>

  OAuth20 = ({ data: { bearer } }) => <>
    <Col size='4'>
      <FormGroup>
        <Label>Token (Bearer)</Label>
        <Input required
          value={bearer}
          name='request_config.auth.oauth.bearer'
        />
      </FormGroup>
    </Col>
  </>

  authOptions = [
    { value: null, label: 'No Auth', component: null },
    { value: 'basic', label: 'Basic Auth', component: this.BasicAuth },
    { value: 'oauth', label: 'OAuth 2.0', component: this.OAuth20, disabled: true },
    { value: 'carapi', label: 'CarApi JWT', component: this.CarApi },
  ]

  Content = () => {
    const [{ component: Component, value, label }, setAuth] = useState(this.authOptions[0])
    const { selected, [value]: data = {} } = this.props.data || {}

    useEffect(() => {
      if (selected) {
        const option = this.authOptions.find(({ value }) => value === selected)
        option && setAuth(option)
      }
    }, [selected])

    return <>
      <FormCard
        render={!!Component}
        title='Auth'
        headerButtons={<div className='relative'>
          <DropdownMenu size='sm'>
            <DropdownMenuTrigger >
              <Button color='accent' size='sm' className='absolute -top-1 right-0'>
                <ChevronDown size={16} />
                {label}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent size='left' align='start' alignOffset={-80}>
              {this.authOptions.map((option, index) => <DropdownMenuItem
                key={index}
                disabled={option.disabled}
                onClick={() => setAuth(option)}
              >
                {option.label}
              </DropdownMenuItem>)}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>}>
        <Input type='hidden'
          value={value || ''}
          name='request_config.auth.selected'
        />
        <Row>
          {Component && <Component data={data} />}
        </Row>
      </FormCard>
    </>
  }

  render() {
    return <this.Content />
  }
}

AuthComponent.propTypes = propTypes
AuthComponent.defaultProps = {}
